goog.provide("shadow.js.shim.module$date_fns$sub$default");
shadow.js.shim.module$date_fns$sub$default = shadow.js.require(147, {})["default"];
